import React, { useState } from "react";
import { Link } from "react-router-dom";
import Spinner from "../components/common/Spinner";
import AuthCard from "./AuthCard";
import { requestPasswordReset } from "../api/studioAPI";
import { colors, typography, buttons, form } from "../styles/index";

// /forgot-password - emails a reset link. The answer is the same whether or not the email has an account.
export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return undefined;
    setError("");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return setError("Please enter a valid work email address.");
    setLoading(true);
    try {
      setSent((await requestPasswordReset(email.trim())).msg);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
    return undefined;
  };

  return (
    <AuthCard subtitle="Reset your password">
      {sent ? (
        <div role="status" style={{ ...typography.small, background: colors.primarySoft, padding: 12, borderRadius: 8 }}>
          {sent} It works for an hour - check your spam folder if it doesn&rsquo;t arrive.
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <p style={{ ...typography.small, color: colors.textMuted }}>Enter your work email and we&rsquo;ll send you a link to choose a new password.</p>
          <div style={{ marginBottom: 16 }}>
            <label style={form.label} htmlFor="email">Work email</label>
            <input id="email" type="email" autoComplete="email" style={form.input} disabled={loading} value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
          </div>
          {error && <div style={{ ...form.error, marginBottom: 12 }} role="alert">{error}</div>}
          <button type="submit" disabled={loading} style={{ ...buttons.primary, width: "100%", opacity: loading ? 0.7 : 1 }}>
            {loading ? <><Spinner size={14} /> Sending...</> : "Send reset link"}
          </button>
        </form>
      )}
      <p style={{ ...typography.small, marginTop: 20, textAlign: "center", color: colors.textMuted }}>
        <Link to="/login">Back to sign in</Link>
      </p>
    </AuthCard>
  );
}
